import { render, staticRenderFns } from "./myreviewrecord.vue?vue&type=template&id=32f88f89&scoped=true&"
import script from "./myreviewrecord.vue?vue&type=script&lang=js&"
export * from "./myreviewrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f88f89",
  null
  
)

export default component.exports